<div class="password-complexity-container">
  <app-password-input
    [passwordInfo]="passwordInfo"
    (onInputChanged)="onPasswordValueChanged($event)"
  ></app-password-input>
  <div class="password-rules">
    <div class="password-rule">
      <img src="wealth-assets/icons/check-circle{{ passwordInfo.rules.length ? '-green' : '' }}.svg" />
      <span [style]="{ color: passwordInfo.rules.length ? '#00CC6D' : '#6E798D' }">حداقل ۸ کاراکتر</span>
    </div>

    <div class="password-rule">
      <img src="wealth-assets/icons/check-circle{{ passwordInfo.rules.lowercase ? '-green' : '' }}.svg" />
      <span
        [style]="{
          color: passwordInfo.rules.lowercase ? '#00CC6D' : '#6E798D',
        }"
        >حداقل یک کاراکتر با حرف کوچک</span
      >
    </div>

    <div class="password-rule">
      <img src="wealth-assets/icons/check-circle{{ passwordInfo.rules.uppercase ? '-green' : '' }}.svg" />
      <span
        [style]="{
          color: passwordInfo.rules.uppercase ? '#00CC6D' : '#6E798D',
        }"
        >حداقل یک کاراکتر با حرف بزرگ</span
      >
    </div>

    <div class="password-rule">
      <img src="wealth-assets/icons/check-circle{{ passwordInfo.rules.number ? '-green' : '' }}.svg" />
      <span [style]="{ color: passwordInfo.rules.number ? '#00CC6D' : '#6E798D' }">حداقل یک عدد</span>
    </div>

    <div class="password-rule">
      <img src="wealth-assets/icons/check-circle{{ passwordInfo.rules.symbol ? '-green' : '' }}.svg" />
      <span [style]="{ color: passwordInfo.rules.symbol ? '#00CC6D' : '#6E798D' }">
        حداقل یک کاراکتر ویژه از قبیل: {{ '!@#$%^&*()-+' }}
      </span>
    </div>
  </div>
  <app-password-input
    [displayIndicator]="false"
    [inputPlaceholder]="'تکرار رمز عبور'"
    [passwordInfo]="repeatPasswordInfo"
    (onInputChanged)="onRepeatPasswordValueChanged($event)"
  ></app-password-input>
</div>
